"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectMinutesSchema = exports.AUTOMATION_COLLECT_MINUTES_MAX = exports.ROW_TRIGGER_QUIET_MS = void 0;
exports.collectWindowMs = collectWindowMs;
exports.isCollectWindowMs = isCollectWindowMs;
exports.collectMinutesOf = collectMinutesOf;
exports.rowTriggerTickMs = rowTriggerTickMs;
exports.rowTriggerCollectDelayMs = rowTriggerCollectDelayMs;
const zod_1 = require("zod");
const schedule_1 = require("./schedule");
/**
 * The rows of a row trigger (new or changed) are collected until this quiet
 * time passes, at most AUTOMATION_MIN_TICK_MS after the first row: an import,
 * several saves or edits of a row become one window instead of a run per
 * save.
 */
exports.ROW_TRIGGER_QUIET_MS = 5_000;
/** The longest window a row trigger may collect: a day. */
exports.AUTOMATION_COLLECT_MINUTES_MAX = 24 * 60;
/**
 * `collectMinutes` of a row trigger: it collects the rows of that many
 * minutes into one window, without a quiet time. Never shorter than the
 * smallest schedule.
 */
exports.CollectMinutesSchema = zod_1.z
    .number()
    .int()
    .min(schedule_1.AUTOMATION_MIN_TICK_MS / 60_000)
    .max(exports.AUTOMATION_COLLECT_MINUTES_MAX);
/** The window of `collectMinutes` in ms; null when the trigger sets none. */
function collectWindowMs(collectMinutes) {
    return collectMinutes == null ? null : collectMinutes * 60_000;
}
/**
 * Whether `value` is a window a row trigger keeps (triggerConfig
 * collectWindowMs): whole minutes within CollectMinutesSchema.
 */
function isCollectWindowMs(value) {
    return (typeof value === 'number' &&
        value % 60_000 === 0 &&
        exports.CollectMinutesSchema.safeParse(value / 60_000).success);
}
/** `collectMinutes` of a window of `windowMs`, as a package names it. */
function collectMinutesOf(windowMs) {
    return windowMs === null ? undefined : windowMs / 60_000;
}
/**
 * The least time between two windows of a row trigger: its own window, else
 * the smallest schedule. No row trigger starts faster than the smallest
 * schedule.
 */
function rowTriggerTickMs(windowMs) {
    return windowMs ?? schedule_1.AUTOMATION_MIN_TICK_MS;
}
/**
 * When the window of a row trigger runs, `now` ms from now: without its own
 * window after the quiet time, at most one tick after the first row
 * (`openedAt`); with a window `windowMs` after the first row. Never before
 * one tick after the previous window ran (`lastTakenAt`).
 */
function rowTriggerCollectDelayMs(openedAt, lastTakenAt, now, windowMs) {
    const tickMs = rowTriggerTickMs(windowMs);
    const due = windowMs === null
        ? Math.min(exports.ROW_TRIGGER_QUIET_MS, openedAt + tickMs - now)
        : openedAt + windowMs - now;
    const tick = lastTakenAt === null ? 0 : lastTakenAt + tickMs - now;
    return Math.max(0, due, tick);
}
//# sourceMappingURL=row-window.js.map